import { buildErrorMessage } from '@constants'
import { AxiosError } from 'axios'
import { useSnackbar } from '@ui/snackbar'

/**
 * The success/error callbacks every KI-Instruktion mutation shares: refresh the list, then confirm
 * with a snackbar; a failure shows the backend error.
 */
const useAIInstructionMutationCallbacks = (invalidate: () => Promise<unknown>) => {
  const { enqueueSnackbar } = useSnackbar()

  return (successMessage: string, errorFallback: string) => ({
    onSuccess: async () => {
      await invalidate()
      enqueueSnackbar(successMessage, { variant: 'success' })
    },
    onError: (error: AxiosError) => {
      enqueueSnackbar(buildErrorMessage(error, errorFallback), { variant: 'error' })
    },
  })
}

export default useAIInstructionMutationCallbacks
